import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\">\n    <title>icon/10pt/下载</title>\n    <g id=\"icon-download_icon/10pt/下载\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\">\n        <polyline id=\"icon-download_路径\" stroke=\"currentColor\" stroke-width=\"10\" points=\"16.5 48.0147556 16.5 80 80.5 80 80.5 48\" />\n        <polyline id=\"icon-download_路径\" stroke=\"currentColor\" stroke-width=\"10\" points=\"64.5 46.2222222 48.5 62.2222222 32.5 46.2222222\" />\n        <line x1=\"48.4852444\" y1=\"16\" x2=\"48\" y2=\"57\" id=\"icon-download_路径\" stroke=\"currentColor\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download.svg
// module id = +H2/
// module chunks = 2